import { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';
import { withI18n } from '@lingui/react';
import { Container, Label } from './input-sc';
import ErrorMessage from './errorMessage';
import { Trans } from '@lingui/react';

const SelectInput = ({
    hidden,
    errors,
    touched,
    name,
    label,
    options,
    onChange,
    hasTranslations,
    i18n,
}) => {
    const [focused, setFocused] = useState(false);
    const [displayValue, setDisplayValue] = useState('');
    const [open, setOpen] = useState(false);

    const { initialValues, setFieldValue, values } = useFormikContext();
    let value = initialValues[name];

    useEffect(() => {
        if (value || displayValue) {
            setFocused(true);
        }
    });

    useEffect(() => {
        let value = options.find(item => item.value === values[name]);
        setDisplayValue(value?.text);
    }, [options]);

    useEffect(() => {
        let value = options.find(item => item.value === values[name]);
        setDisplayValue(value?.text);
        if (onChange) onChange(value?.value);
    }, [values[name]]);

    let buildOptions = options.map(option => {
        return (
            <div
                key={option.value}
                className={
                    option.value === values[name] ? 'selected' : 'option'
                }
                onClick={() => {
                    setOpen(false);
                    setFieldValue(name, option.value);
                }}
            >
                {hasTranslations ? <Trans id={option.text} /> : option.text}
            </div>
        );
    });

    const focus = e => {
        e.persist();
        if (!e.target.classList.contains('option')) {
            setOpen(true);
        }
        setFocused(true);
    };

    return (
        <Wrapper hidden={hidden}>
            <Container
                onFocus={focus}
                focused={focused}
                tabIndex="0"
                onMouseLeave={() => setOpen(false)}
            >
                <Label
                    htmlFor={name + '__id'}
                    onClick={focus}
                    focused={focused}
                >
                    {label}
                </Label>

                <StyledSelect
                    open={open}
                    displayValue={displayValue}
                    onClick={focus}
                    id={name + '__id'}
                >
                    <div className={'select'}>
                        <div
                            className={'displayValue'}
                            onClick={() => {
                                setOpen(!open);
                            }}
                        >
                            {hasTranslations ? (
                                <Trans id={displayValue} />
                            ) : (
                                displayValue
                            )}
                        </div>
                        <div
                            onMouseLeave={() => setOpen(false)}
                            className={open ? 'options' : 'options hide'}
                        >
                            {buildOptions}
                        </div>
                    </div>
                </StyledSelect>
            </Container>
            <ErrorMessage show={errors[name]}>{errors[name]}</ErrorMessage>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

//https://codepen.io/dk0/pen/xXwxvK
const StyledSelect = styled.div`
    text-align: left !important;
    padding-left: 5px;
    .options {
        padding-top: 8px;
        padding-bottom: 8px;
        left: 3px;
        width: 98%;
        background: #fff;
        opacity: ${({ open }) => (open ? 1 : 0)};
        max-height: ${({ open }) => (open ? '15rem' : 0)};
        height: fit-content;
        overflow-y: auto;
        position: absolute;
        z-index: 999999;
        border-radius: 4px;
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
            0px 8px 10px 1px rgba(0, 0, 0, 0.14),
            0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        transition: 0.25s opacity ease-in-out, 0.25s max-height ease-in-out;
        visibility: visible;
    }
    .options.hide {
        visibility: hidden;
    }

    .displayValue {
        padding-top: ${({ displayValue }) =>
            displayValue || false ? '9px' : '20px'};
        padding-bottom: ${({ displayValue }) =>
            displayValue || false ? '9px' : '20px'};
        padding-right: 35px;
    }

    .selected {
        background-color: rgba(0, 0, 0, 0.08);
    }

    cursor: pointer;

    .options > div {
        padding: 0.5rem;
        cursor: pointer;
        &:hover {
            background-color: rgba(0, 0, 0, 0.08);
        }
    }

    .select {
        background: none;
        &:after {
            content: '';
            border: solid black;
            border-width: 0 2px 2px 0;
            display: inline-block;
            padding: 3px;
            position: absolute;
            top: 40%;
            right: 20px;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
        }
    }
`;

export default withI18n()(SelectInput);
